import React, { useState } from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";

import { TableRow, TableCell, Box, Button } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import { Delete } from "@material-ui/icons";
import TestsRequests from "services/tests";
import CustomDialog from "../AccessList/CustomDialog";
import UsedByDialog from "./UsedByDialog";

const useStyles = makeStyles((theme) => ({
  tableRowRoot: {
    position: "relative",
    transition: "all .2s",
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    "&:hover, &.active": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      "& $tableCellRoot, & $titleRoot": {
        color: theme.palette.text.primary,
      },
    },
    "&:last-child": {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: `0 3px 10px 0 ${alpha(theme.palette.common.dark, 0.2)}`,
      borderTopColor: "transparent",
    },
    "&.collapse-table-row": {
      borderTop: "0 none",
      "& $tableCellRoot": {
        padding: 0,
      },
    },
    "&.active": {
      borderTop: "0 none",
      "&:hover": {
        transform: "none",
        boxShadow: "none",
      },
    },
  },
  tableCellRoot: {
    padding: 6,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.text.secondary,
    borderBottom: "0 none",
    position: "relative",
    "&:first-child": {
      paddingLeft: 24,
    },
    "&:last-child": {
      textAlign: "right",
      paddingRight: 24,
    },
  },
  tableCellFirst: {
    minWidth: "150px",
  },
  titleRoot: {
    color: theme.palette.text.secondary,
    letterSpacing: 0.25,
  },
  createIconContainer: {
    background: "transparent",
    color: theme.palette.secondary.main,
    width: "35px",
    height: "35px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px",
    cursor: "pointer",
  },
  tableActionContainer: {
    direction: "rtl",
  },
}));

const KeyManagementTableItem = ({ data, id }) => {
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();

  const { keys, keysCurrentPage } = useSelector(({ tests }) => tests);

  const handleDeleteKey = () => {
    setOpenRemoveDialog(false);
    dispatch(TestsRequests.removeKey(id, keys.length, keysCurrentPage));
  };

  const openDetailsDialogfn = () => {
    if (data.used) {
      if (data.usedBy) {
        setOpenDetailsDialog(true);
      }
    }
  };

  return (
    <React.Fragment>
      <TableRow className={clsx(classes.tableRowRoot)}>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {data.key}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {data.description}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {data.prize.map((item) => {
            return (
              <div>
                {item.type === "JoftPoochScore"
                  ? "پله جفت پوچ" + " : " + item.value
                  : "کلید جفت پوچ" + " : " + item.value}
              </div>
            );
          })}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {data.type === "JoftPooch" ? "جفت پوچ" : ""}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableCellFirst)}
        >
          {data.used ? (
            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={openDetailsDialogfn}
            >
              اطلاعات فرد
            </Button>
          ) : (
            ""
          )}
        </TableCell>
        <TableCell
          className={clsx(classes.tableCellRoot, classes.tableActionContainer)}
        >
          <Box
            className={classes.createIconContainer}
            onClick={() => setOpenRemoveDialog(true)}
          >
            <Delete />
          </Box>
        </TableCell>
      </TableRow>
      <CustomDialog
        text={"آیا از حذف دسترسی این مورد اطمینان دارید؟"}
        open={openRemoveDialog}
        handleClose={() => setOpenRemoveDialog(false)}
        action={handleDeleteKey}
      />
      <UsedByDialog
        open={openDetailsDialog}
        handleClose={() => setOpenDetailsDialog(false)}
        data={data?.usedBy}
      />
    </React.Fragment>
  );
};

export default KeyManagementTableItem;
